import { request } from '@/shared/api/request'

export const get = (externalId) => {
	return request({ url: 'proactive/get/' + externalId, method: 'GET' })
}
